import { ref, onMounted } from 'vue'
import { groupProductsQuery } from '../utils/data'
import { storefrontFetch } from '@/js/utils/storefront'

export default {
  props: {
    tagGroup: {
      type: String,
      required: false,
      default: null
    }
  },

  setup (props) {
    const swatchProducts = ref([])

    onMounted(async () => {
      if (!props.tagGroup) return

      let cursor = null
      const allProducts = []

      do {
        const data = await storefrontFetch(groupProductsQuery, {
          cursor,
          groupTag: `tag:'${props.tagGroup}'`
        })
        // console.log('groupProductsQuery data', data)

        if (!data || !data.products) break

        const edges = data.products.edges
        allProducts.push(...edges.map(e => e.node))

        cursor = data.products.pageInfo.hasNextPage
          ? data.products.pageInfo.endCursor
          : null
      } while (cursor)

      // Filter for exact tag matches only
      const filteredProducts = allProducts.filter(product =>
        product.tags.some(tag => tag === props.tagGroup)
      )

      swatchProducts.value = filteredProducts
    })

    const openVTO = (sku, swatchProds) => {
      if (window.openVTO) {
        window.openVTO(sku, swatchProds)
      }
    }

    return {
      swatchProducts,
      openVTO
    }
  }
}
